
import type { TenantPluginRegister } from '@yeshuman/sdk'
import {
  CandidateDashboard,
  EmployerDashboard,
  InterviewerDashboard,
  RecruiterDashboard,
} from './dashboards'
import { CandidateRoutes } from './routes/candidate-routes'
import { EmployerRoutes } from './routes/employer-routes'
import { InterviewerRoutes } from './routes/interviewer-routes'
import { RecruiterRoutes } from './routes/recruiter-routes'

export const register: TenantPluginRegister = (app) => {
  app.focus.register({
    focus: 'candidate',
    home: CandidateDashboard,
    tree: CandidateRoutes,
    skeleton: 'candidate',
  })
  app.focus.register({
    focus: 'employer',
    home: EmployerDashboard,
    tree: EmployerRoutes,
    skeleton: 'employer',
  })
  app.focus.register({ focus: 'recruiter', home: RecruiterDashboard, tree: RecruiterRoutes })
  app.focus.register({ focus: 'interviewer', home: InterviewerDashboard, tree: InterviewerRoutes })

  app.routes.named('opportunities.manage', '/employer/jobs')
  app.routes.named('opportunity.manage', '/employer/jobs/:id')
  app.routes.named('organisation.opportunities', '/employer/organisations/:slug/jobs')

  app.nav.add('candidate', [
    { path: '/candidate', icon: 'Home', exact: true, label: 'Home' },
    { path: '/profile', icon: 'User' },
    { path: '/candidate/jobs', icon: 'BriefcaseBusiness' },
  ])
  app.nav.add('employer', [
    { path: '/employer', icon: 'Home', exact: true, label: 'Home' },
    { path: '/employer/jobs', icon: 'BriefcaseBusiness', label: 'Job Openings' },
    { path: '/employer/organisations', icon: 'Building2' },
  ])
  app.nav.add('recruiter', [
    { path: '/recruiter', icon: 'Home', exact: true, label: 'Home' },
    { path: '/recruiter/briefs', icon: 'FileText', label: 'Briefs' },
    { path: '/recruiter/talent', icon: 'Search' },
    { path: '/recruiter/pipeline', icon: 'LayoutGrid', label: 'Talent Pipeline' },
  ])
  app.nav.add('interviewer', [
    { path: '/interviewer', icon: 'Home', exact: true, label: 'Home' },
    { path: '/interviewer/candidates', icon: 'Users', label: 'Candidates' },
    { path: '/interviewer/interviews', icon: 'CalendarCheck', label: 'Interviews' },
  ])
  app.nav.add('platform', [
    {
      path: '/platform/skills-catalog',
      icon: 'BookOpen',
      label: 'Skill Lexicon',
      after: '/platform/classifiers',
    },
    {
      path: '/platform/marketplace-ingest',
      icon: 'Globe2',
      requiresFeature: 'opportunityIngest',
      label: 'Marketplace ingest',
      after: '/platform/organisations',
    },
  ])
}
